import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import TestCard from "./TestCard";
import Tabs from "./Tabs";
import "./PaperListing.css";

export default function PyqListing() {
  //  SAFE SELECTORS
  // const pyqYearPaperList = useSelector(
  //   (state) => state.examSlice.pyqYearPaperList || []
  // );

  const selectedPyqYear = useSelector(
    (state) => state.examSlice.selectedPyqYear
  );
// const aitsList = useSelector((state) => state.aitsTests.list);
// const aitsTabs = useSelector((state) => state.aitsTests.tabs);
const pyqYearPaperList = useSelector(
  (state) => state.examSlice.pyqYearPaperList || []
); 

const selectedType = useSelector(
  (state) => state.examSlice.selectedType
);

const selectedPyqCategory = useSelector(
  (state) => state.examSlice.selectedPyqCategory
);

  const tabs = ["All Tests", "Completed"];

  const [activeTab, setActiveTab] = useState("All Tests");

  useEffect(() => {
    setActiveTab("All Tests");
  }, [selectedPyqYear]);

  // const list =
  //   selectedPyqYear && pyqYearPaperList.length
  //     ? pyqYearPaperList
  //         .filter(
  //           (g) => String(g.target_year) === String(selectedPyqYear)
  //         )
  //         .flatMap((g) => g.data || [])
  //     : [];

 const list =
    selectedPyqYear && pyqYearPaperList.length
      ? pyqYearPaperList
          .filter(
            (group) =>
              String(group.target_year) === String(selectedPyqYear) &&
              group.target_value === selectedPyqCategory
          )
          .flatMap((group) => group.data || [])
    : [];


useEffect(() => {
  console.log("FINAL RENDER LIST:", list);

  list.forEach((t, i) => {
    console.log(
      `CARD ${i + 1}`,
      t.paper_name,
      "| paper_id:",
      t.paper_id,
      "| max_marks:",
      t.max_marks
    );
  });
}, [list]);


  const filteredTests =
    activeTab === "All Tests"
      ? list
      : list.filter((test) => test.tab_name === activeTab);

      

  return (
    <div className="paperListingWrapper">
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <div className="paperListingContent">
        {filteredTests.length > 0 ? (
          filteredTests.map((test) => (
            <TestCard
              key={test.paper_id}
              test={test}
              isPyq
            />
          ))
        ) : (
          <p className="no_tests_text">No tests found.</p>
        )}
      </div>
    </div>
  );
}
